import { get, post } from "helpers/api_helper";

const getResponseData = response => response?.data || [];

export const getSchools = async () => {
  const response = await get("/schools");
  return getResponseData(response);
};

export const getRoles = async () => {
  const response = await get("/role", {
    params: {
      is_teacher: true,
    },
  });

  return getResponseData(response);
};

export const createSuperTeachers = data => {
  return post("/teacher/add_superteacher", { data });
};
